<template>
  <div>
    <h1>{{ $t('pageAboutProjectTitle') }}</h1>
    <p v-html="$t('pageAboutProjectText')"/>
  </div>
</template>

<script>
export default {
}
</script>

<style>

</style>
